import { json } from "d3-fetch";
import { hierarchy, treemap } from "d3-hierarchy";
import { select, selectAll, style } from "d3-selection";

export const d3 = {
  json,
  hierarchy,
  select,
  selectAll,
  style,
  treemap,
};
